import { FETCH_PEAK, FETCH_MEANF, FETCH_SEEING } from '../types/performance';

const initialState = {
  seeingspeak: [],
  seeingsflux: [],
 seeingseeing: [],
  
};


/* store generation seeingspeak seeingsflux seeingseeing with type FETCH_PEAK, FETCH_MEANF, FETCH_SEEING

  seeingspeak: [],
  seeingsflux: [],
 seeingseeing: [],
      case FETCH_PEAK:
      return { ...state, seeingspeak: [action.payload] };

      case FETCH_MEANF:
        return { ...state, seeingsflux: [action.payload] };
    
      case FETCH_SEEING:



*/


export default (state = initialState,action) => {
  switch (action.type) {

    case FETCH_PEAK:
      return { ...state, seeingspeak: [action.payload] };

      case FETCH_MEANF:
        return { ...state, seeingsflux: [action.payload] };
    
      case FETCH_SEEING:
        return { ...state, seeingseeing: [action.payload] };
    
    default:
      return state;
  }
};
